import { SIZE } from '../../../../constants/general.js';
import styles from '../index.module.scss.js';

const COLOR_OPTION = {
    ERROR: 'error',
    SECONDARY: 'secondary',
};
const VARIANT_OPTION = {
    CONTAINED: 'contained',
    OUTLINED: 'outlined',
    TEXT: 'text',
};
const VARIANT = Object.freeze({
    [VARIANT_OPTION.CONTAINED]: styles.button__contained,
    [VARIANT_OPTION.OUTLINED]: styles.button__outlined,
    [VARIANT_OPTION.TEXT]: styles.button__text,
});
const COLOR = Object.freeze({
    contained: {
        [COLOR_OPTION.ERROR]: styles['button__contained--error'],
        [COLOR_OPTION.SECONDARY]: styles['button__contained--secondary'],
    },
    outlined: {
        [COLOR_OPTION.ERROR]: styles['button__outlined--error'],
        // outlined and text variants does not have secondary styles, yet, so no class is added. But we need it for ts indexing on the component.
        [COLOR_OPTION.SECONDARY]: null,
    },
    text: {
        [COLOR_OPTION.ERROR]: styles['button__text--error'],
        [COLOR_OPTION.SECONDARY]: null,
    },
});
const BUTTON_SIZES = Object.freeze({
    [SIZE.M]: styles.button__medium,
    [SIZE.L]: styles.button__large,
});
const ICON_BUTTON = Object.freeze({
    [SIZE.M]: styles.button__medium_icon,
    [SIZE.L]: styles.button__large_icon,
});
const TEXT_ICON_STYLES = Object.freeze({
    [SIZE.M]: [styles.button__medium_icon_left, styles.button__medium_icon_right],
    [SIZE.L]: [styles.button__large_icon_left, styles.button__large_icon_right],
});

export { BUTTON_SIZES, COLOR, COLOR_OPTION, ICON_BUTTON, TEXT_ICON_STYLES, VARIANT, VARIANT_OPTION };
